<template>
  <div>
    <div class="py-3">
      <div
        id="carouselExampleIndicators"
        class="carousel slide position-static"
        data-bs-ride="true"
      >
        <div class="carousel-indicators">
          <button
            v-for="i in pairs"
            :key="i - 1"
            class="bg-info rounded-circle m-2 w-11-px h-10-px"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            :data-bs-slide-to="i - 1"
            :class="{ active: i - 1 === 0 }"
            :aria-current="i - 1 === 0"
          ></button>
        </div>
        <div class="carousel-inner py-5 px-3">
          <div
            v-for="j in pairs"
            :key="j - 1"
            class="carousel-item"
            :class="{ active: j - 1 === 0 }"
          >
            <div class="row g-5">
              <blog-article
                :article="articles[(j - 1) * 2]"
                class="col-12 col-lg-6"
              />
              <blog-article
                v-if="j !== pairs || articles.length % 2 === 0"
                :article="articles[2 * (j - 1) + 1]"
                class="col-12 col-lg-6"
              />
            </div>
          </div>
        </div>

        <button
          class="carousel-control-prev px-3 px-md-5 w-20-px"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span
            class="carousel-control-prev-icon text-secondary"
            aria-hidden="true"
          >
            <i class="fa fa-4x fa-caret-left opacity-75"></i>
          </span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next px-3 px-md-5 w-20-px"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span
            class="carousel-control-next-icon text-secondary"
            aria-hidden="true"
          >
            <i class="fa fa-4x fa-caret-right opacity-75"></i>
          </span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselArticles",
};
</script>

<script setup>
import { defineProps, ref } from "vue";
import BlogArticle from "@/components/blog/index/background-card/BlogArticle";

const pairs = ref(
  props.articles.length % 2 === 0
    ? parseInt(props.articles.length / 2)
    : parseInt(props.articles.length / 2) + 1
);
const props = defineProps({
  articles: {
    type: Array,
  },
});
</script>

<style scoped></style>
